import React, { useEffect, useState } from "react";
import './Collection.css'
import VerticalNavbar from "./VerticalNavbar/VerticalNavbar";
import ItemDetail from "./ItemDetail/ItemDetail";
import { urlApiServer } from "../../Config/Config";


// const urlGetLines = `${urlApiServer}coleccions?populate[lineas_images][fields][0]=nombre&populate[lineas_images][fields][1]=orientacion&populate[lineas_images][populate][Imagen][fields][0]=url&populate[lineas_images][populate][Imagen][fields][1]=name&populate[color_principal][fields][0]=codigo_hexadecimal&populate[color_secundario][fields][0]=codigo_hexadecimal&populate[logos_izquierda][fields][0]=url&populate[logos_izquierda][fields][1]=name&populate[logos_derecha][fields][0]=url&populate[logos_derecha][fields][1]=name&populate[Logo][fields][0]=url&populate[Logo][fields][1]=name`
const urlGetLines = `${urlApiServer}coleccions?populate[imagenes_linea][populate]=Imagen&populate[color_principals][fields][0]=codigo_hexadecimal&populate[color_secundarios][fields][0]=codigo_hexadecimal&populate[logos_izquierda][fields][0]=url&populate[logos_izquierda][fields][1]=name&populate[logos_derecha][fields][0]=url&populate[logos_derecha][fields][1]=name&populate[Logo][fields][0]=url&populate[Logo][fields][1]=name&populate[color_principals][fields]=codigo_hexadecimal`

function Collection() {
  const [activeItem, setActiveItem] = useState(0);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [data, setData] = useState([])
    // const isPortraitMobile = window.matchMedia("(orientation: portrait)").matches;


    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetLines, requestOptions)
                    .then(response => response.json())
                    .then(value => {
                      // Asegurar que siempre sea un array
                      setData(Array.isArray(value.data) ? value.data : []);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente desactivado');
                setData([]); // Asegurar que sea un array vacío en caso de error
            }
        })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);
useEffect(()=>{
},[data, activeItem])

  const handleItemClick = (item) => {
    // console.log("activeItem: ", item)
    setActiveItem(item);
  };

  return (
    <div className="collection-container">
      <VerticalNavbar
        items={data}
        onItemClick={handleItemClick}
        activeItem={activeItem}
      />
      <div className="content-area">
        {/* {activeItem && <ItemDetail item={data[activeItem]} windowHeight={windowHeight} />} */}
        {data.length > 0 && <ItemDetail item={data[activeItem]} windowHeight={windowHeight} />}
      </div>
    </div>
  );
}

export default Collection;